export enum KeyEnum {
	'error',
	'warning',
	'info',
	'success',
	'message',
	'close',
	'form-description',
	'of',
	'characters',
	'new',
	'no-entries',
	'change-order',
	'action-running',
	'action-done',
	'page-first',
	'page-back',
	'page-next',
	'page-last',
	'entries-per-site',
	'page-current',
	'page-selected',
	'page-per-site',
	'logo-description',
	'open-link-in-tab',
	'kolibri-logo',
}
